class ArticlesGrid extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.pages = this.getAttribute("data-pages");
  }

  connectedCallback() {
    const options = {
      root: null,
      rootMargin: "-200px 0px 0px 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fetchData();
        }
      });
    }, options);

    observer.observe(this.parentElement.parentElement.nextElementSibling);
    if (this.currentPage >= this.pages) {
      observer.unobserve(this.parentElement.parentElement.nextElementSibling);
    }
  }

  async fetchData() {
    if (this.currentPage >= this.pages) {
      return;
    }
    this.currentPage = this.currentPage + 1;
    const url = new URL(window.location.href);
    url.searchParams.set("page", this.currentPage);
    url.searchParams.set("section_id", "blog-articles-grid");
    try {
      this.dataset.loading = true;
      const response = await fetch(url);
      const data = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(data, "text/html");
      const elements = Array.from(
        html.body.firstElementChild.firstElementChild.children,
      );
      elements.forEach((element, index) => {
        if (index === elements.length - 1) {
          return;
        }
        this.appendChild(element);
      });
      this.dataset.loading = false;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
}

customElements.define("articles-grid", ArticlesGrid);
